import { FormControlSizes, FormattedMessage, NavButton, useWLOrgConfigContext, type WLBlotterKeys } from '@talos/kyoko';

export function CustomHyperlinkButtons({ blotter }: { blotter: WLBlotterKeys }) {
  const { config } = useWLOrgConfigContext();

  if (config.customBlotterHyperlinkButtons == null) {
    return null;
  }

  const buttons = config.customBlotterHyperlinkButtons.filter(
    btn => btn.blotters == null || btn.blotters.includes(blotter)
  );

  if (buttons.length === 0) {
    return null;
  }

  return (
    <>
      {buttons.map(btn => (
        <NavButton key={btn.href} to={btn.href} size={FormControlSizes.Small} target="_blank" rel="noopener noreferrer">
          {btn.labelTranslationKey == null ? (
            btn.label
          ) : (
            <FormattedMessage id={btn.labelTranslationKey} defaultMessage={btn.label} />
          )}
        </NavButton>
      ))}
    </>
  );
}
